<script setup lang="ts">
import {Tag} from "@/tag/interfaces/Tag";
import TagService from "@/tag/services/TagService";

defineProps<{tags: Tag[] }>();
</script>

<template>
  <component
    :is="TagService.firstIconForTags(tags)"
    v-if="TagService.firstIconForTags(tags)"
    class="w-4 h-4 text-primary"
  />
</template>

<style scoped>

</style>
